<form [formGroup]="commonForm" (ngSubmit)="onSubmit()">
  <p class="common-info">Provide basic information about your workspace.</p>
  <div class="document-content">
    <h3 class="section-title">Information</h3>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label for="name">Name</mat-label>
      <input matInput id="name" formControlName="name" placeholder="e.g., HR Onboarding Workflow" />

      @if (commonFormControls.name.errors?.['required'] && commonFormControls.name.touched) {
        <mat-error> Name is required. </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      @if (templateIsLoading$ | async) {
        <mat-progress-bar class="mat-form-loader" mode="indeterminate"></mat-progress-bar>
      }
      <mat-label>Select template document</mat-label>

      <mat-select formControlName="templateId" placeholder="Choose an element">
        @if (uniqueTemplates$ | async; as templates) {
          @for (template of templates; track template.id) {
            <mat-option [value]="template.id"> {{ template.name }} </mat-option>
          }
        } @else {
          <mat-option disabled>No elements available.</mat-option>
        }
      </mat-select>
      <mat-hint>You can't change this later!</mat-hint>

      @if (commonFormControls.templateId.errors?.['required'] && commonFormControls.templateId.touched) {
        <mat-error>Template document required. </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      @if (templateIsLoading$ | async) {
        <mat-progress-bar class="mat-form-loader" mode="indeterminate"></mat-progress-bar>
      }
      <mat-label>Select template version</mat-label>

      <mat-select formControlName="templateVersion" placeholder="Choose an element">
        @if (availableVersions$ | async; as versions) {
          @if (versions.length > 0) {
            @for (version of versions; track version) {
              <mat-option [value]="version.version">
                {{ version.version }}
              </mat-option>
            }
          } @else {
            <mat-option disabled>No versions available.</mat-option>
          }
        }
      </mat-select>
      <mat-hint>You can't change this later!</mat-hint>

      @if (commonFormControls.templateVersion.errors?.['required'] && commonFormControls.templateVersion.touched) {
        <mat-error>Template version required. </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label for="description">Description</mat-label>
      <textarea
        matInput
        id="description"
        formControlName="description"
        placeholder="e.g., A dedicated workspace for managing new employee onboarding processes..."
        rows="5"
        cdkTextareaAutosize
        #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="3"
        cdkAutosizeMaxRows="8"></textarea>
      @if (commonFormControls.description.errors?.['required'] && commonFormControls.description.touched) {
        <mat-error> Description is required. </mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label for="docAiInfo">Document Ai context information</mat-label>
      <textarea
        matInput
        id="docAiInfo"
        formControlName="docAiInfo"
        placeholder="This will be used as context to generate some of the document's part"
        rows="5"
        cdkTextareaAutosize
        #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="3"
        cdkAutosizeMaxRows="8"></textarea>
      @if (commonFormControls.docAiInfo.errors?.['required'] && commonFormControls.docAiInfo.touched) {
        <mat-error> Document Ai context information is required. </mat-error>
      }
      <mat-hint>This will be used to add context for the ai agent during the document creation process!</mat-hint>
    </mat-form-field>

    @if (saveButtonIsActive) {
      <div class="button-holder">
        <app-loader-button
          [loading]="loading"
          type="submit"
          [disabled]="loading || isArchived"
          mat-flat-button
          color="primary">
          Save
        </app-loader-button>
      </div>
    }
  </div>
</form>
